import { useState, useCallback } from "react";

/**
 * DC-UX-SIDEBAR-NO-PERSIST-DEFAULT-COLLAPSED-006: Hook for in-memory sidebar collapsed state.
 * 
 * Default: collapsed = true (logs panel hidden on load)
 * No persistence - state resets on refresh/rejoin
 * 
 * @returns {[boolean, (value: boolean) => void]} [collapsed, setCollapsed]
 */
export function useSidebarCollapsed() {
  // In-memory state only, default to collapsed (true)
  const [collapsed, setCollapsed] = useState(true);

  // Toggle helper for convenience
  const toggleCollapsed = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  return [collapsed, setCollapsed, toggleCollapsed];
}
